import { render, staticRenderFns } from "./UnitDetails.vue?vue&type=template&id=76f5cec2&"
import script from "./UnitDetails.vue?vue&type=script&lang=js&"
export * from "./UnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports